import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import ComunityRadaria from "../../../../assets/images/ComunidadDeRadaria-Aux.webp";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";
import { useNavigate } from "react-router-dom";
import {
  setAllRunningsClubs,
  setRunningsClubsOfUser,
} from "../../../../redux/slice/runningsClubsSlice";
import {
  filterRunningClubDontUser,
  filterRunningClubOfuser,
} from "./filterRunningClubs";
import {
  getAllRunningsClubsAPI,
  leaveRunningClubAPI,
} from "../../../../services/rest/runningsClubs/runningClubUser";

const ModalGoOutRunningClub = ({ setOpen, runningClub, open, setLoading }) => {
  const { _id } = useSelector((state) => state.userReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const leaveClub = async () => {
    try {
      setLoading(true);
      await leaveRunningClubAPI(runningClub?._id);
      const getAll = await getAllRunningsClubsAPI();
      const runningsClubsOfUser = filterRunningClubOfuser(getAll, _id);
      const AllRunnningClubs = filterRunningClubDontUser(getAll, _id);
      dispatch(
        setAllRunningsClubs({ allRunningsClubs: AllRunnningClubs ?? [] })
      );
      dispatch(
        setRunningsClubsOfUser({ runningsClubsOfUser: runningsClubsOfUser })
      );
      toast.success("Has salido de la comunidad con exito.");
      setLoading(false);
      handleClose();
      navigate("/dashboard/runnings-clubs");
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`No se pudo salir de la comunidad. \n ${message}`);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 9999 }}
    >
      <DialogTitle>¿Quieres salir del club de corredores?</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <img
            src={runningClub?.urlImg ?? ComunityRadaria}
            alt="Comunidad Radaria"
            style={{ width: 200, height: "auto" }}
          />
          <Typography variant="h6" sx={{ marginTop: 2 }}>
            {runningClub?.nameRunningClub}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button variant="outlined" color="#e7ef7d" onClick={leaveClub}>
          Salir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalGoOutRunningClub;
